import { IntlImperialUnitFormattingService } from './intl-imperial-unit-formatting-service';
import { IntlMetricUnitFormattingService } from './intl-metric-unit-formatting-service';

export const UNIT_GRAM = 'gram';
export const UNIT_KILOGRAM = 'kilogram';
export const UNIT_POUND = 'pound';
export const UNIT_OUNCE = 'ounce';
export const UNIT_OUNCES = 'Ounces';
export const UNIT_CENTIMETER = 'centimeter';
export const UNIT_INCH = 'inch';

export const INTL_NUMBER_STYLE_UNIT = 'unit';

export const INTL_NUMBER_UNIT_DISPLAY_SHORT = 'short';

const getUnitFormattingService = (unitOfMeasure = UNIT_OUNCES) => {
  // todo make this get the correct seller setting  'UnitOfMeasure:Weight'
  if (unitOfMeasure === 'Grams' || unitOfMeasure === 'Centimeters') {
    return IntlMetricUnitFormattingService;
  }
  return IntlImperialUnitFormattingService;
};

class IntlUnitFormattingServiceClass {
  formatWeight(weight, unitOfMeasure = UNIT_OUNCES) {
    if (!weight) {
      return '';
    }
    const { value, unit } = weight;
    return getUnitFormattingService(unitOfMeasure).formatWeight({
      value,
      unit,
    });
  }

  formatDimensions(dimensions, unitOfMeasure = 'Inches') {
    if (!dimensions) {
      return '';
    }

    return getUnitFormattingService(unitOfMeasure).formatDimensions(dimensions);
  }
}

export const IntlUnitFormattingService = new IntlUnitFormattingServiceClass();
